/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type GetActiveServiceBreakLocationsHubsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
}>

export type GetActiveServiceBreakLocationsHubsQuery = {
  __typename?: 'Query'
  serviceBreakLocations: {
    __typename?: 'ServiceBreakLocationsResponse'
    serviceBreakLocations: Array<{
      __typename?: 'ServiceBreakLocation'
      id: string
      name: string
    }>
  }
}

export const GetActiveServiceBreakLocationsHubsDocument = gql`
    query getActiveServiceBreakLocationsHubs($regionId: ID!) {
  serviceBreakLocations(
    input: {regionId: $regionId, filters: {states: [ACTIVE], types: [HUB]}}
  ) {
    serviceBreakLocations {
      id
      name
    }
  }
}
    `

/**
 * __useGetActiveServiceBreakLocationsHubsQuery__
 *
 * To run a query within a React component, call `useGetActiveServiceBreakLocationsHubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveServiceBreakLocationsHubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveServiceBreakLocationsHubsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useGetActiveServiceBreakLocationsHubsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActiveServiceBreakLocationsHubsQuery,
    GetActiveServiceBreakLocationsHubsQueryVariables
  > &
    (
      | {
          variables: GetActiveServiceBreakLocationsHubsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetActiveServiceBreakLocationsHubsQuery,
    GetActiveServiceBreakLocationsHubsQueryVariables
  >(GetActiveServiceBreakLocationsHubsDocument, options)
}
export function useGetActiveServiceBreakLocationsHubsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActiveServiceBreakLocationsHubsQuery,
    GetActiveServiceBreakLocationsHubsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetActiveServiceBreakLocationsHubsQuery,
    GetActiveServiceBreakLocationsHubsQueryVariables
  >(GetActiveServiceBreakLocationsHubsDocument, options)
}
// @ts-ignore
export function useGetActiveServiceBreakLocationsHubsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetActiveServiceBreakLocationsHubsQuery,
    GetActiveServiceBreakLocationsHubsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetActiveServiceBreakLocationsHubsQuery,
  GetActiveServiceBreakLocationsHubsQueryVariables
>
export function useGetActiveServiceBreakLocationsHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActiveServiceBreakLocationsHubsQuery,
        GetActiveServiceBreakLocationsHubsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetActiveServiceBreakLocationsHubsQuery | undefined,
  GetActiveServiceBreakLocationsHubsQueryVariables
>
export function useGetActiveServiceBreakLocationsHubsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetActiveServiceBreakLocationsHubsQuery,
        GetActiveServiceBreakLocationsHubsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetActiveServiceBreakLocationsHubsQuery,
    GetActiveServiceBreakLocationsHubsQueryVariables
  >(GetActiveServiceBreakLocationsHubsDocument, options)
}
export type GetActiveServiceBreakLocationsHubsQueryHookResult = ReturnType<
  typeof useGetActiveServiceBreakLocationsHubsQuery
>
export type GetActiveServiceBreakLocationsHubsLazyQueryHookResult = ReturnType<
  typeof useGetActiveServiceBreakLocationsHubsLazyQuery
>
export type GetActiveServiceBreakLocationsHubsSuspenseQueryHookResult =
  ReturnType<typeof useGetActiveServiceBreakLocationsHubsSuspenseQuery>
export type GetActiveServiceBreakLocationsHubsQueryResult = Apollo.QueryResult<
  GetActiveServiceBreakLocationsHubsQuery,
  GetActiveServiceBreakLocationsHubsQueryVariables
>
